/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EstadoRouteImport } from './routes/estado'
import { Route as RankingRouteImport } from './routes/ranking'
import { Route as StatusRouteImport } from './routes/status'
import { Route as AppSellerRouteImport } from './routes/app/_seller'
import { Route as AppLoginRouteImport } from './routes/app/login'
import { Route as AppRegisterRouteImport } from './routes/app/register'
import { Route as AuthLinkRouteImport } from './routes/auth/link'
import { Route as PayTokenRouteImport } from './routes/pay/$token'
import { Route as PortalOwnerRouteImport } from './routes/portal/_owner'
import { Route as PortalLoginRouteImport } from './routes/portal/login'
import { Route as RCodeRouteImport } from './routes/r/$code'
import { Route as AppSellerIndexRouteImport } from './routes/app/_seller/index'
import { Route as AppSellerAdminRouteRouteImport } from './routes/app/_seller/admin/route'
import { Route as AppSellerChangesRouteImport } from './routes/app/_seller/changes'
import { Route as AppSellerContactsRouteImport } from './routes/app/_seller/contacts'
import { Route as AppSellerDriveRouteImport } from './routes/app/_seller/drive'
import { Route as AppSellerMapRouteImport } from './routes/app/_seller/map'
import { Route as DevCheckoutIdRouteImport } from './routes/dev/checkout/$id'
import { Route as PayResultRefRouteImport } from './routes/pay/result/$ref'
import { Route as PortalOwnerIndexRouteImport } from './routes/portal/_owner/index'
import { Route as AppSellerAdminIndexRouteImport } from './routes/app/_seller/admin/index'
import { Route as AppSellerAdminCycleRouteImport } from './routes/app/_seller/admin/cycle'
import { Route as AppSellerAdminFraudRouteImport } from './routes/app/_seller/admin/fraud'
import { Route as AppSellerAdminJobsRouteImport } from './routes/app/_seller/admin/jobs'
import { Route as AppSellerAdminMessagesRouteImport } from './routes/app/_seller/admin/messages'
import { Route as AppSellerAdminPayoutsRouteImport } from './routes/app/_seller/admin/payouts'
import { Route as AppSellerAdminSellersRouteImport } from './routes/app/_seller/admin/sellers'
import { Route as AppSellerAdminSitesRouteImport } from './routes/app/_seller/admin/sites'
import { Route as AppSellerLeadsIndexRouteImport } from './routes/app/_seller/leads/index'
import { Route as AppSellerLeadsLeadIdRouteImport } from './routes/app/_seller/leads/$leadId'
import { Route as AppSellerMoreIndexRouteImport } from './routes/app/_seller/more/index'
import { Route as AppSellerMoreCommissionsRouteImport } from './routes/app/_seller/more/commissions'
import { Route as AppSellerMoreCustomPageRouteImport } from './routes/app/_seller/more/custom-page'
import { Route as AppSellerMoreGalleryRouteImport } from './routes/app/_seller/more/gallery'
import { Route as AppSellerMoreNotificationsRouteImport } from './routes/app/_seller/more/notifications'
import { Route as AppSellerMoreReferralsRouteImport } from './routes/app/_seller/more/referrals'
import { Route as AppSellerMoreTemplatesRouteImport } from './routes/app/_seller/more/templates'
import { Route as AppSellerSitesIndexRouteImport } from './routes/app/_seller/sites/index'
import { Route as AppSellerSitesSiteIdRouteImport } from './routes/app/_seller/sites/$siteId'
import { Route as AppSitesSiteIdEditorRouteImport } from './routes/app/sites.$siteId.editor'
import { Route as PortalOwnerSitesIndexRouteImport } from './routes/portal/_owner/sites/index'
import { Route as PortalOwnerSitesSiteIdRouteImport } from './routes/portal/_owner/sites/$siteId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EstadoRoute = EstadoRouteImport.update({
  id: '/estado',
  path: '/estado',
  getParentRoute: () => rootRouteImport,
} as any)
const RankingRoute = RankingRouteImport.update({
  id: '/ranking',
  path: '/ranking',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSellerRoute = AppSellerRouteImport.update({
  id: '/app/_seller',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLoginRoute = AppLoginRouteImport.update({
  id: '/app/login',
  path: '/app/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRegisterRoute = AppRegisterRouteImport.update({
  id: '/app/register',
  path: '/app/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLinkRoute = AuthLinkRouteImport.update({
  id: '/auth/link',
  path: '/auth/link',
  getParentRoute: () => rootRouteImport,
} as any)
const PayTokenRoute = PayTokenRouteImport.update({
  id: '/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalOwnerRoute = PortalOwnerRouteImport.update({
  id: '/portal/_owner',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalLoginRoute = PortalLoginRouteImport.update({
  id: '/portal/login',
  path: '/portal/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RCodeRoute = RCodeRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSellerIndexRoute = AppSellerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerAdminRouteRoute = AppSellerAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerChangesRoute = AppSellerChangesRouteImport.update({
  id: '/changes',
  path: '/changes',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerContactsRoute = AppSellerContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerDriveRoute = AppSellerDriveRouteImport.update({
  id: '/drive',
  path: '/drive',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerMapRoute = AppSellerMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppSellerRoute,
} as any)
const DevCheckoutIdRoute = DevCheckoutIdRouteImport.update({
  id: '/dev/checkout/$id',
  path: '/dev/checkout/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PayResultRefRoute = PayResultRefRouteImport.update({
  id: '/pay/result/$ref',
  path: '/pay/result/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalOwnerIndexRoute = PortalOwnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalOwnerRoute,
} as any)
const AppSellerAdminIndexRoute = AppSellerAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminCycleRoute = AppSellerAdminCycleRouteImport.update({
  id: '/cycle',
  path: '/cycle',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminFraudRoute = AppSellerAdminFraudRouteImport.update({
  id: '/fraud',
  path: '/fraud',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminJobsRoute = AppSellerAdminJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminMessagesRoute = AppSellerAdminMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminPayoutsRoute = AppSellerAdminPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminSellersRoute = AppSellerAdminSellersRouteImport.update({
  id: '/sellers',
  path: '/sellers',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerAdminSitesRoute = AppSellerAdminSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AppSellerAdminRouteRoute,
} as any)
const AppSellerLeadsIndexRoute = AppSellerLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerLeadsLeadIdRoute = AppSellerLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerMoreIndexRoute = AppSellerMoreIndexRouteImport.update({
  id: '/more/',
  path: '/more/',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerMoreCommissionsRoute =
  AppSellerMoreCommissionsRouteImport.update({
    id: '/more/commissions',
    path: '/more/commissions',
    getParentRoute: () => AppSellerRoute,
  } as any)
const AppSellerMoreCustomPageRoute = AppSellerMoreCustomPageRouteImport.update({
  id: '/more/custom-page',
  path: '/more/custom-page',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerMoreGalleryRoute = AppSellerMoreGalleryRouteImport.update({
  id: '/more/gallery',
  path: '/more/gallery',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerMoreNotificationsRoute =
  AppSellerMoreNotificationsRouteImport.update({
    id: '/more/notifications',
    path: '/more/notifications',
    getParentRoute: () => AppSellerRoute,
  } as any)
const AppSellerMoreReferralsRoute = AppSellerMoreReferralsRouteImport.update({
  id: '/more/referrals',
  path: '/more/referrals',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerMoreTemplatesRoute = AppSellerMoreTemplatesRouteImport.update({
  id: '/more/templates',
  path: '/more/templates',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerSitesIndexRoute = AppSellerSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSellerSitesSiteIdRoute = AppSellerSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => AppSellerRoute,
} as any)
const AppSitesSiteIdEditorRoute = AppSitesSiteIdEditorRouteImport.update({
  id: '/app/sites/$siteId/editor',
  path: '/app/sites/$siteId/editor',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalOwnerSitesIndexRoute = PortalOwnerSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => PortalOwnerRoute,
} as any)
const PortalOwnerSitesSiteIdRoute = PortalOwnerSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => PortalOwnerRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/estado': typeof EstadoRoute
  '/ranking': typeof RankingRoute
  '/status': typeof StatusRoute
  '/app': typeof AppSellerRouteWithChildren
  '/app/login': typeof AppLoginRoute
  '/app/register': typeof AppRegisterRoute
  '/auth/link': typeof AuthLinkRoute
  '/pay/$token': typeof PayTokenRoute
  '/portal': typeof PortalOwnerRouteWithChildren
  '/portal/login': typeof PortalLoginRoute
  '/r/$code': typeof RCodeRoute
  '/app/admin': typeof AppSellerAdminRouteRouteWithChildren
  '/app/changes': typeof AppSellerChangesRoute
  '/app/contacts': typeof AppSellerContactsRoute
  '/app/drive': typeof AppSellerDriveRoute
  '/app/map': typeof AppSellerMapRoute
  '/dev/checkout/$id': typeof DevCheckoutIdRoute
  '/pay/result/$ref': typeof PayResultRefRoute
  '/app/': typeof AppSellerIndexRoute
  '/portal/': typeof PortalOwnerIndexRoute
  '/app/admin/cycle': typeof AppSellerAdminCycleRoute
  '/app/admin/fraud': typeof AppSellerAdminFraudRoute
  '/app/admin/jobs': typeof AppSellerAdminJobsRoute
  '/app/admin/messages': typeof AppSellerAdminMessagesRoute
  '/app/admin/payouts': typeof AppSellerAdminPayoutsRoute
  '/app/admin/sellers': typeof AppSellerAdminSellersRoute
  '/app/admin/sites': typeof AppSellerAdminSitesRoute
  '/app/leads/$leadId': typeof AppSellerLeadsLeadIdRoute
  '/app/more/commissions': typeof AppSellerMoreCommissionsRoute
  '/app/more/custom-page': typeof AppSellerMoreCustomPageRoute
  '/app/more/gallery': typeof AppSellerMoreGalleryRoute
  '/app/more/notifications': typeof AppSellerMoreNotificationsRoute
  '/app/more/referrals': typeof AppSellerMoreReferralsRoute
  '/app/more/templates': typeof AppSellerMoreTemplatesRoute
  '/app/sites/$siteId': typeof AppSellerSitesSiteIdRoute
  '/app/sites/$siteId/editor': typeof AppSitesSiteIdEditorRoute
  '/portal/sites/$siteId': typeof PortalOwnerSitesSiteIdRoute
  '/app/admin/': typeof AppSellerAdminIndexRoute
  '/app/leads/': typeof AppSellerLeadsIndexRoute
  '/app/more/': typeof AppSellerMoreIndexRoute
  '/app/sites/': typeof AppSellerSitesIndexRoute
  '/portal/sites/': typeof PortalOwnerSitesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/estado': typeof EstadoRoute
  '/ranking': typeof RankingRoute
  '/status': typeof StatusRoute
  '/app/login': typeof AppLoginRoute
  '/app/register': typeof AppRegisterRoute
  '/auth/link': typeof AuthLinkRoute
  '/pay/$token': typeof PayTokenRoute
  '/portal/login': typeof PortalLoginRoute
  '/r/$code': typeof RCodeRoute
  '/app/changes': typeof AppSellerChangesRoute
  '/app/contacts': typeof AppSellerContactsRoute
  '/app/drive': typeof AppSellerDriveRoute
  '/app/map': typeof AppSellerMapRoute
  '/dev/checkout/$id': typeof DevCheckoutIdRoute
  '/pay/result/$ref': typeof PayResultRefRoute
  '/app': typeof AppSellerIndexRoute
  '/portal': typeof PortalOwnerIndexRoute
  '/app/admin/cycle': typeof AppSellerAdminCycleRoute
  '/app/admin/fraud': typeof AppSellerAdminFraudRoute
  '/app/admin/jobs': typeof AppSellerAdminJobsRoute
  '/app/admin/messages': typeof AppSellerAdminMessagesRoute
  '/app/admin/payouts': typeof AppSellerAdminPayoutsRoute
  '/app/admin/sellers': typeof AppSellerAdminSellersRoute
  '/app/admin/sites': typeof AppSellerAdminSitesRoute
  '/app/leads/$leadId': typeof AppSellerLeadsLeadIdRoute
  '/app/more/commissions': typeof AppSellerMoreCommissionsRoute
  '/app/more/custom-page': typeof AppSellerMoreCustomPageRoute
  '/app/more/gallery': typeof AppSellerMoreGalleryRoute
  '/app/more/notifications': typeof AppSellerMoreNotificationsRoute
  '/app/more/referrals': typeof AppSellerMoreReferralsRoute
  '/app/more/templates': typeof AppSellerMoreTemplatesRoute
  '/app/sites/$siteId': typeof AppSellerSitesSiteIdRoute
  '/app/sites/$siteId/editor': typeof AppSitesSiteIdEditorRoute
  '/portal/sites/$siteId': typeof PortalOwnerSitesSiteIdRoute
  '/app/admin': typeof AppSellerAdminIndexRoute
  '/app/leads': typeof AppSellerLeadsIndexRoute
  '/app/more': typeof AppSellerMoreIndexRoute
  '/app/sites': typeof AppSellerSitesIndexRoute
  '/portal/sites': typeof PortalOwnerSitesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/estado': typeof EstadoRoute
  '/ranking': typeof RankingRoute
  '/status': typeof StatusRoute
  '/app/_seller': typeof AppSellerRouteWithChildren
  '/app/login': typeof AppLoginRoute
  '/app/register': typeof AppRegisterRoute
  '/auth/link': typeof AuthLinkRoute
  '/pay/$token': typeof PayTokenRoute
  '/portal/_owner': typeof PortalOwnerRouteWithChildren
  '/portal/login': typeof PortalLoginRoute
  '/r/$code': typeof RCodeRoute
  '/app/_seller/admin': typeof AppSellerAdminRouteRouteWithChildren
  '/app/_seller/changes': typeof AppSellerChangesRoute
  '/app/_seller/contacts': typeof AppSellerContactsRoute
  '/app/_seller/drive': typeof AppSellerDriveRoute
  '/app/_seller/map': typeof AppSellerMapRoute
  '/dev/checkout/$id': typeof DevCheckoutIdRoute
  '/pay/result/$ref': typeof PayResultRefRoute
  '/app/_seller/': typeof AppSellerIndexRoute
  '/portal/_owner/': typeof PortalOwnerIndexRoute
  '/app/_seller/admin/cycle': typeof AppSellerAdminCycleRoute
  '/app/_seller/admin/fraud': typeof AppSellerAdminFraudRoute
  '/app/_seller/admin/jobs': typeof AppSellerAdminJobsRoute
  '/app/_seller/admin/messages': typeof AppSellerAdminMessagesRoute
  '/app/_seller/admin/payouts': typeof AppSellerAdminPayoutsRoute
  '/app/_seller/admin/sellers': typeof AppSellerAdminSellersRoute
  '/app/_seller/admin/sites': typeof AppSellerAdminSitesRoute
  '/app/_seller/leads/$leadId': typeof AppSellerLeadsLeadIdRoute
  '/app/_seller/more/commissions': typeof AppSellerMoreCommissionsRoute
  '/app/_seller/more/custom-page': typeof AppSellerMoreCustomPageRoute
  '/app/_seller/more/gallery': typeof AppSellerMoreGalleryRoute
  '/app/_seller/more/notifications': typeof AppSellerMoreNotificationsRoute
  '/app/_seller/more/referrals': typeof AppSellerMoreReferralsRoute
  '/app/_seller/more/templates': typeof AppSellerMoreTemplatesRoute
  '/app/_seller/sites/$siteId': typeof AppSellerSitesSiteIdRoute
  '/app/sites/$siteId/editor': typeof AppSitesSiteIdEditorRoute
  '/portal/_owner/sites/$siteId': typeof PortalOwnerSitesSiteIdRoute
  '/app/_seller/admin/': typeof AppSellerAdminIndexRoute
  '/app/_seller/leads/': typeof AppSellerLeadsIndexRoute
  '/app/_seller/more/': typeof AppSellerMoreIndexRoute
  '/app/_seller/sites/': typeof AppSellerSitesIndexRoute
  '/portal/_owner/sites/': typeof PortalOwnerSitesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/estado'
    | '/ranking'
    | '/status'
    | '/app'
    | '/app/login'
    | '/app/register'
    | '/auth/link'
    | '/pay/$token'
    | '/portal'
    | '/portal/login'
    | '/r/$code'
    | '/app/admin'
    | '/app/changes'
    | '/app/contacts'
    | '/app/drive'
    | '/app/map'
    | '/dev/checkout/$id'
    | '/pay/result/$ref'
    | '/app/'
    | '/portal/'
    | '/app/admin/cycle'
    | '/app/admin/fraud'
    | '/app/admin/jobs'
    | '/app/admin/messages'
    | '/app/admin/payouts'
    | '/app/admin/sellers'
    | '/app/admin/sites'
    | '/app/leads/$leadId'
    | '/app/more/commissions'
    | '/app/more/custom-page'
    | '/app/more/gallery'
    | '/app/more/notifications'
    | '/app/more/referrals'
    | '/app/more/templates'
    | '/app/sites/$siteId'
    | '/app/sites/$siteId/editor'
    | '/portal/sites/$siteId'
    | '/app/admin/'
    | '/app/leads/'
    | '/app/more/'
    | '/app/sites/'
    | '/portal/sites/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/estado'
    | '/ranking'
    | '/status'
    | '/app/login'
    | '/app/register'
    | '/auth/link'
    | '/pay/$token'
    | '/portal/login'
    | '/r/$code'
    | '/app/changes'
    | '/app/contacts'
    | '/app/drive'
    | '/app/map'
    | '/dev/checkout/$id'
    | '/pay/result/$ref'
    | '/app'
    | '/portal'
    | '/app/admin/cycle'
    | '/app/admin/fraud'
    | '/app/admin/jobs'
    | '/app/admin/messages'
    | '/app/admin/payouts'
    | '/app/admin/sellers'
    | '/app/admin/sites'
    | '/app/leads/$leadId'
    | '/app/more/commissions'
    | '/app/more/custom-page'
    | '/app/more/gallery'
    | '/app/more/notifications'
    | '/app/more/referrals'
    | '/app/more/templates'
    | '/app/sites/$siteId'
    | '/app/sites/$siteId/editor'
    | '/portal/sites/$siteId'
    | '/app/admin'
    | '/app/leads'
    | '/app/more'
    | '/app/sites'
    | '/portal/sites'
  id:
    | '__root__'
    | '/'
    | '/estado'
    | '/ranking'
    | '/status'
    | '/app/_seller'
    | '/app/login'
    | '/app/register'
    | '/auth/link'
    | '/pay/$token'
    | '/portal/_owner'
    | '/portal/login'
    | '/r/$code'
    | '/app/_seller/admin'
    | '/app/_seller/changes'
    | '/app/_seller/contacts'
    | '/app/_seller/drive'
    | '/app/_seller/map'
    | '/dev/checkout/$id'
    | '/pay/result/$ref'
    | '/app/_seller/'
    | '/portal/_owner/'
    | '/app/_seller/admin/cycle'
    | '/app/_seller/admin/fraud'
    | '/app/_seller/admin/jobs'
    | '/app/_seller/admin/messages'
    | '/app/_seller/admin/payouts'
    | '/app/_seller/admin/sellers'
    | '/app/_seller/admin/sites'
    | '/app/_seller/leads/$leadId'
    | '/app/_seller/more/commissions'
    | '/app/_seller/more/custom-page'
    | '/app/_seller/more/gallery'
    | '/app/_seller/more/notifications'
    | '/app/_seller/more/referrals'
    | '/app/_seller/more/templates'
    | '/app/_seller/sites/$siteId'
    | '/app/sites/$siteId/editor'
    | '/portal/_owner/sites/$siteId'
    | '/app/_seller/admin/'
    | '/app/_seller/leads/'
    | '/app/_seller/more/'
    | '/app/_seller/sites/'
    | '/portal/_owner/sites/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EstadoRoute: typeof EstadoRoute
  RankingRoute: typeof RankingRoute
  StatusRoute: typeof StatusRoute
  AppSellerRoute: typeof AppSellerRouteWithChildren
  AppLoginRoute: typeof AppLoginRoute
  AppRegisterRoute: typeof AppRegisterRoute
  AuthLinkRoute: typeof AuthLinkRoute
  PayTokenRoute: typeof PayTokenRoute
  PortalOwnerRoute: typeof PortalOwnerRouteWithChildren
  PortalLoginRoute: typeof PortalLoginRoute
  RCodeRoute: typeof RCodeRoute
  DevCheckoutIdRoute: typeof DevCheckoutIdRoute
  PayResultRefRoute: typeof PayResultRefRoute
  AppSitesSiteIdEditorRoute: typeof AppSitesSiteIdEditorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/estado': {
      id: '/estado'
      path: '/estado'
      fullPath: '/estado'
      preLoaderRoute: typeof EstadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ranking': {
      id: '/ranking'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof RankingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/_seller': {
      id: '/app/_seller'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppSellerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/login': {
      id: '/app/login'
      path: '/app/login'
      fullPath: '/app/login'
      preLoaderRoute: typeof AppLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/register': {
      id: '/app/register'
      path: '/app/register'
      fullPath: '/app/register'
      preLoaderRoute: typeof AppRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/link': {
      id: '/auth/link'
      path: '/auth/link'
      fullPath: '/auth/link'
      preLoaderRoute: typeof AuthLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$token': {
      id: '/pay/$token'
      path: '/pay/$token'
      fullPath: '/pay/$token'
      preLoaderRoute: typeof PayTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/_owner': {
      id: '/portal/_owner'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalOwnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/login': {
      id: '/portal/login'
      path: '/portal/login'
      fullPath: '/portal/login'
      preLoaderRoute: typeof PortalLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$code': {
      id: '/r/$code'
      path: '/r/$code'
      fullPath: '/r/$code'
      preLoaderRoute: typeof RCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/_seller/': {
      id: '/app/_seller/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppSellerIndexRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/admin': {
      id: '/app/_seller/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppSellerAdminRouteRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/changes': {
      id: '/app/_seller/changes'
      path: '/changes'
      fullPath: '/app/changes'
      preLoaderRoute: typeof AppSellerChangesRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/contacts': {
      id: '/app/_seller/contacts'
      path: '/contacts'
      fullPath: '/app/contacts'
      preLoaderRoute: typeof AppSellerContactsRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/drive': {
      id: '/app/_seller/drive'
      path: '/drive'
      fullPath: '/app/drive'
      preLoaderRoute: typeof AppSellerDriveRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/map': {
      id: '/app/_seller/map'
      path: '/map'
      fullPath: '/app/map'
      preLoaderRoute: typeof AppSellerMapRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/dev/checkout/$id': {
      id: '/dev/checkout/$id'
      path: '/dev/checkout/$id'
      fullPath: '/dev/checkout/$id'
      preLoaderRoute: typeof DevCheckoutIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/result/$ref': {
      id: '/pay/result/$ref'
      path: '/pay/result/$ref'
      fullPath: '/pay/result/$ref'
      preLoaderRoute: typeof PayResultRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/_owner/': {
      id: '/portal/_owner/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalOwnerIndexRouteImport
      parentRoute: typeof PortalOwnerRoute
    }
    '/app/_seller/admin/': {
      id: '/app/_seller/admin/'
      path: '/'
      fullPath: '/app/admin/'
      preLoaderRoute: typeof AppSellerAdminIndexRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/cycle': {
      id: '/app/_seller/admin/cycle'
      path: '/cycle'
      fullPath: '/app/admin/cycle'
      preLoaderRoute: typeof AppSellerAdminCycleRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/fraud': {
      id: '/app/_seller/admin/fraud'
      path: '/fraud'
      fullPath: '/app/admin/fraud'
      preLoaderRoute: typeof AppSellerAdminFraudRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/jobs': {
      id: '/app/_seller/admin/jobs'
      path: '/jobs'
      fullPath: '/app/admin/jobs'
      preLoaderRoute: typeof AppSellerAdminJobsRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/messages': {
      id: '/app/_seller/admin/messages'
      path: '/messages'
      fullPath: '/app/admin/messages'
      preLoaderRoute: typeof AppSellerAdminMessagesRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/payouts': {
      id: '/app/_seller/admin/payouts'
      path: '/payouts'
      fullPath: '/app/admin/payouts'
      preLoaderRoute: typeof AppSellerAdminPayoutsRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/sellers': {
      id: '/app/_seller/admin/sellers'
      path: '/sellers'
      fullPath: '/app/admin/sellers'
      preLoaderRoute: typeof AppSellerAdminSellersRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/admin/sites': {
      id: '/app/_seller/admin/sites'
      path: '/sites'
      fullPath: '/app/admin/sites'
      preLoaderRoute: typeof AppSellerAdminSitesRouteImport
      parentRoute: typeof AppSellerAdminRouteRoute
    }
    '/app/_seller/leads/': {
      id: '/app/_seller/leads/'
      path: '/leads'
      fullPath: '/app/leads/'
      preLoaderRoute: typeof AppSellerLeadsIndexRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/leads/$leadId': {
      id: '/app/_seller/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/app/leads/$leadId'
      preLoaderRoute: typeof AppSellerLeadsLeadIdRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/': {
      id: '/app/_seller/more/'
      path: '/more'
      fullPath: '/app/more/'
      preLoaderRoute: typeof AppSellerMoreIndexRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/commissions': {
      id: '/app/_seller/more/commissions'
      path: '/more/commissions'
      fullPath: '/app/more/commissions'
      preLoaderRoute: typeof AppSellerMoreCommissionsRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/custom-page': {
      id: '/app/_seller/more/custom-page'
      path: '/more/custom-page'
      fullPath: '/app/more/custom-page'
      preLoaderRoute: typeof AppSellerMoreCustomPageRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/gallery': {
      id: '/app/_seller/more/gallery'
      path: '/more/gallery'
      fullPath: '/app/more/gallery'
      preLoaderRoute: typeof AppSellerMoreGalleryRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/notifications': {
      id: '/app/_seller/more/notifications'
      path: '/more/notifications'
      fullPath: '/app/more/notifications'
      preLoaderRoute: typeof AppSellerMoreNotificationsRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/referrals': {
      id: '/app/_seller/more/referrals'
      path: '/more/referrals'
      fullPath: '/app/more/referrals'
      preLoaderRoute: typeof AppSellerMoreReferralsRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/more/templates': {
      id: '/app/_seller/more/templates'
      path: '/more/templates'
      fullPath: '/app/more/templates'
      preLoaderRoute: typeof AppSellerMoreTemplatesRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/sites/': {
      id: '/app/_seller/sites/'
      path: '/sites'
      fullPath: '/app/sites/'
      preLoaderRoute: typeof AppSellerSitesIndexRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/_seller/sites/$siteId': {
      id: '/app/_seller/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/app/sites/$siteId'
      preLoaderRoute: typeof AppSellerSitesSiteIdRouteImport
      parentRoute: typeof AppSellerRoute
    }
    '/app/sites/$siteId/editor': {
      id: '/app/sites/$siteId/editor'
      path: '/app/sites/$siteId/editor'
      fullPath: '/app/sites/$siteId/editor'
      preLoaderRoute: typeof AppSitesSiteIdEditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/_owner/sites/': {
      id: '/portal/_owner/sites/'
      path: '/sites'
      fullPath: '/portal/sites/'
      preLoaderRoute: typeof PortalOwnerSitesIndexRouteImport
      parentRoute: typeof PortalOwnerRoute
    }
    '/portal/_owner/sites/$siteId': {
      id: '/portal/_owner/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/portal/sites/$siteId'
      preLoaderRoute: typeof PortalOwnerSitesSiteIdRouteImport
      parentRoute: typeof PortalOwnerRoute
    }
  }
}

interface AppSellerAdminRouteRouteChildren {
  AppSellerAdminCycleRoute: typeof AppSellerAdminCycleRoute
  AppSellerAdminFraudRoute: typeof AppSellerAdminFraudRoute
  AppSellerAdminJobsRoute: typeof AppSellerAdminJobsRoute
  AppSellerAdminMessagesRoute: typeof AppSellerAdminMessagesRoute
  AppSellerAdminPayoutsRoute: typeof AppSellerAdminPayoutsRoute
  AppSellerAdminSellersRoute: typeof AppSellerAdminSellersRoute
  AppSellerAdminSitesRoute: typeof AppSellerAdminSitesRoute
  AppSellerAdminIndexRoute: typeof AppSellerAdminIndexRoute
}

const AppSellerAdminRouteRouteChildren: AppSellerAdminRouteRouteChildren = {
  AppSellerAdminCycleRoute: AppSellerAdminCycleRoute,
  AppSellerAdminFraudRoute: AppSellerAdminFraudRoute,
  AppSellerAdminJobsRoute: AppSellerAdminJobsRoute,
  AppSellerAdminMessagesRoute: AppSellerAdminMessagesRoute,
  AppSellerAdminPayoutsRoute: AppSellerAdminPayoutsRoute,
  AppSellerAdminSellersRoute: AppSellerAdminSellersRoute,
  AppSellerAdminSitesRoute: AppSellerAdminSitesRoute,
  AppSellerAdminIndexRoute: AppSellerAdminIndexRoute,
}

const AppSellerAdminRouteRouteWithChildren =
  AppSellerAdminRouteRoute._addFileChildren(AppSellerAdminRouteRouteChildren)

interface AppSellerRouteChildren {
  AppSellerAdminRouteRoute: typeof AppSellerAdminRouteRouteWithChildren
  AppSellerChangesRoute: typeof AppSellerChangesRoute
  AppSellerContactsRoute: typeof AppSellerContactsRoute
  AppSellerDriveRoute: typeof AppSellerDriveRoute
  AppSellerMapRoute: typeof AppSellerMapRoute
  AppSellerIndexRoute: typeof AppSellerIndexRoute
  AppSellerLeadsLeadIdRoute: typeof AppSellerLeadsLeadIdRoute
  AppSellerMoreCommissionsRoute: typeof AppSellerMoreCommissionsRoute
  AppSellerMoreCustomPageRoute: typeof AppSellerMoreCustomPageRoute
  AppSellerMoreGalleryRoute: typeof AppSellerMoreGalleryRoute
  AppSellerMoreNotificationsRoute: typeof AppSellerMoreNotificationsRoute
  AppSellerMoreReferralsRoute: typeof AppSellerMoreReferralsRoute
  AppSellerMoreTemplatesRoute: typeof AppSellerMoreTemplatesRoute
  AppSellerSitesSiteIdRoute: typeof AppSellerSitesSiteIdRoute
  AppSellerLeadsIndexRoute: typeof AppSellerLeadsIndexRoute
  AppSellerMoreIndexRoute: typeof AppSellerMoreIndexRoute
  AppSellerSitesIndexRoute: typeof AppSellerSitesIndexRoute
}

const AppSellerRouteChildren: AppSellerRouteChildren = {
  AppSellerAdminRouteRoute: AppSellerAdminRouteRouteWithChildren,
  AppSellerChangesRoute: AppSellerChangesRoute,
  AppSellerContactsRoute: AppSellerContactsRoute,
  AppSellerDriveRoute: AppSellerDriveRoute,
  AppSellerMapRoute: AppSellerMapRoute,
  AppSellerIndexRoute: AppSellerIndexRoute,
  AppSellerLeadsLeadIdRoute: AppSellerLeadsLeadIdRoute,
  AppSellerMoreCommissionsRoute: AppSellerMoreCommissionsRoute,
  AppSellerMoreCustomPageRoute: AppSellerMoreCustomPageRoute,
  AppSellerMoreGalleryRoute: AppSellerMoreGalleryRoute,
  AppSellerMoreNotificationsRoute: AppSellerMoreNotificationsRoute,
  AppSellerMoreReferralsRoute: AppSellerMoreReferralsRoute,
  AppSellerMoreTemplatesRoute: AppSellerMoreTemplatesRoute,
  AppSellerSitesSiteIdRoute: AppSellerSitesSiteIdRoute,
  AppSellerLeadsIndexRoute: AppSellerLeadsIndexRoute,
  AppSellerMoreIndexRoute: AppSellerMoreIndexRoute,
  AppSellerSitesIndexRoute: AppSellerSitesIndexRoute,
}

const AppSellerRouteWithChildren = AppSellerRoute._addFileChildren(
  AppSellerRouteChildren,
)

interface PortalOwnerRouteChildren {
  PortalOwnerIndexRoute: typeof PortalOwnerIndexRoute
  PortalOwnerSitesSiteIdRoute: typeof PortalOwnerSitesSiteIdRoute
  PortalOwnerSitesIndexRoute: typeof PortalOwnerSitesIndexRoute
}

const PortalOwnerRouteChildren: PortalOwnerRouteChildren = {
  PortalOwnerIndexRoute: PortalOwnerIndexRoute,
  PortalOwnerSitesSiteIdRoute: PortalOwnerSitesSiteIdRoute,
  PortalOwnerSitesIndexRoute: PortalOwnerSitesIndexRoute,
}

const PortalOwnerRouteWithChildren = PortalOwnerRoute._addFileChildren(
  PortalOwnerRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EstadoRoute: EstadoRoute,
  RankingRoute: RankingRoute,
  StatusRoute: StatusRoute,
  AppSellerRoute: AppSellerRouteWithChildren,
  AppLoginRoute: AppLoginRoute,
  AppRegisterRoute: AppRegisterRoute,
  AuthLinkRoute: AuthLinkRoute,
  PayTokenRoute: PayTokenRoute,
  PortalOwnerRoute: PortalOwnerRouteWithChildren,
  PortalLoginRoute: PortalLoginRoute,
  RCodeRoute: RCodeRoute,
  DevCheckoutIdRoute: DevCheckoutIdRoute,
  PayResultRefRoute: PayResultRefRoute,
  AppSitesSiteIdEditorRoute: AppSitesSiteIdEditorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
